'use client';
import { ComponentType } from 'react';
import { Props as NewsletterUpdateProps } from './newsletter-update.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicNewsletterUpdateComponent: ComponentType<NewsletterUpdateProps> = dynamic(
  () => import('./newsletter-update.component')
);

export default DynamicNewsletterUpdateComponent;

export function calculateNewsletterUpdatePlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 220 },
    { sinceWidth: 768, height: 260 },
    { sinceWidth: 1024, height: 300 }
  ];
  return { heightSinceWidth };
}
